import { render, staticRenderFns } from "./HelpCenterSeller.vue?vue&type=template&id=1b8e8a74&scoped=true"
import script from "./HelpCenterSeller.vue?vue&type=script&lang=js"
export * from "./HelpCenterSeller.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterSeller.vue?vue&type=style&index=0&id=1b8e8a74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8e8a74",
  null
  
)

export default component.exports